import React from 'react';
import ReactDOM from 'react-dom';
import 'accordium-react-ui-toolkit/crater/register';
import './styles/engage.scss';
import '../common/scss/main.scss';
import App from './App';
import { reportAccessibility } from '../common/utils/reportAccessibility';

ReactDOM.render(<App />, document.getElementById('root'));
reportAccessibility(React);
